var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "simple-form flex col-2" }, [
      _c("div", { staticClass: "form-group center" }, [
        _vm._m(1),
        _vm._v(" "),
        _c("div", { staticClass: "form-value" }, [
          _c("span", [_vm._v(_vm._s(_vm.orderGoodsAllocForm.title))])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-group center" }, [
        _vm._m(2),
        _vm._v(" "),
        _c("div", { staticClass: "form-value" }, [
          _c("span", [_vm._v(_vm._s(_vm.orderGoodsAllocForm.desireArriveDate))])
        ])
      ]),
      _vm._v(" "),
      _vm.orderGoodsAllocForm.orderNo != null
        ? _c("div", { staticClass: "form-group center" }, [
            _vm._m(3),
            _vm._v(" "),
            _c("div", { staticClass: "form-value" }, [
              _c("span", [_vm._v(_vm._s(_vm.orderGoodsAllocForm.orderNo))])
            ])
          ])
        : _vm._e()
    ]),
    _vm._v(" "),
    _vm._m(4),
    _vm._v(" "),
    _c("table", { staticClass: "custom-tbl" }, [
      _vm._m(5),
      _vm._v(" "),
      _c("tbody", { staticClass: "body" }, [
        _vm.retailerCom != null
          ? _c("tr", { staticClass: "row" }, [
              _c("td", { staticStyle: { "text-align": "left" } }, [
                _vm._v(_vm._s(_vm.retailerCom.bizUnitName))
              ]),
              _vm._v(" "),
              _c("td", { staticStyle: { "text-align": "left" } }, [
                _vm._v(_vm._s(_vm.retailerCom.name))
              ]),
              _vm._v(" "),
              _c("td", { staticStyle: { "text-align": "left" } }, [
                _vm._v(
                  _vm._s(_vm.retailerCom.regionName + _vm.retailerCom.street)
                )
              ]),
              _vm._v(" "),
              _c("td", { staticStyle: { "text-align": "left" } }, [
                _vm._v(_vm._s(_vm.retailerCom.contactEmail))
              ])
            ])
          : _c("tr", { staticClass: "row" }, [
              _c("td", { attrs: { colspan: "3" } }, [_vm._v("暂无机构信息")])
            ])
      ])
    ]),
    _vm._v(" "),
    _vm._m(6),
    _vm._v(" "),
    _c("table", { staticClass: "custom-tbl" }, [
      _vm._m(7),
      _vm._v(" "),
      _c("tbody", { staticClass: "body" }, [
        _vm.retailerCom != null
          ? _c("tr", { staticClass: "row" }, [
              _c("td", { staticStyle: { "text-align": "left" } }, [
                _c("div", [
                  _vm._v(_vm._s(_vm.orderGoodsAllocForm.buyerRecvRegionName))
                ])
              ]),
              _vm._v(" "),
              _c("td", { staticStyle: { "text-align": "left" } }, [
                _c("div", [
                  _vm._v(_vm._s(_vm.orderGoodsAllocForm.buyerRecvStreet))
                ])
              ]),
              _vm._v(" "),
              _c("td", { staticStyle: { "text-align": "left" } }, [
                _c("div", [
                  _vm._v(_vm._s(_vm.orderGoodsAllocForm.buyerRecvContractName))
                ])
              ]),
              _vm._v(" "),
              _c("td", { staticStyle: { "text-align": "left" } }, [
                _c("div", [
                  _vm._v(_vm._s(_vm.orderGoodsAllocForm.buyerRecvContactTel))
                ])
              ])
            ])
          : _vm._e()
      ])
    ]),
    _vm._v(" "),
    _vm._m(8),
    _vm._v(" "),
    _c("div", { staticClass: "simple-form" }, [
      _c("div", { staticClass: "form-group center" }, [
        _vm._m(9),
        _vm._v(" "),
        _c("div", { staticClass: "form-value" }, [
          _c("span", [_vm._v(_vm._s(_vm.orderGoodsAllocForm.sellerName))])
        ])
      ])
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "table-layout" },
      [
        _c(
          "el-form",
          { attrs: { model: _vm.orderGoodsAllocForm } },
          [
            _c(
              "el-table",
              {
                ref: "multipleTable",
                staticStyle: { width: "100%" },
                attrs: {
                  data: _vm.orderGoodsAllocForm.itemList,
                  border: "",
                  "tooltip-effect": "dark"
                }
              },
              [
                _vm.showAssetInfo
                  ? _c(
                      "el-table-column",
                      { attrs: { align: "center", label: "资产信息" } },
                      [
                        _c("el-table-column", {
                          attrs: {
                            align: "left",
                            prop: "devcName",
                            label: "名称"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            align: "left",
                            prop: "devcCatName",
                            label: "分类"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            align: "left",
                            prop: "devcBrandName",
                            label: "品牌"
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "el-table-column",
                  { attrs: { align: "center", label: "商品信息" } },
                  [
                    _c("el-table-column", {
                      attrs: { align: "left", prop: "title", label: "名称" }
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: { align: "left", prop: "catName", label: "分类" }
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: { align: "left", prop: "brandName", label: "品牌" }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    align: "center",
                    prop: "asmblAccFlag",
                    label: "组装件",
                    width: "80"
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function(scope) {
                        return [
                          scope.row.asmblAccFlag
                            ? _c("span", [_vm._v("是")])
                            : _c("span", [_vm._v("否")])
                        ]
                      }
                    }
                  ])
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { align: "center", width: "80", label: "关联定义" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function(rows) {
                        return [
                          rows.row.assetDefId != null
                            ? _c("div", { staticClass: "inline-block" }, [
                                _vm._v("已关联")
                              ])
                            : _c("div", { staticClass: "inline-block" }, [
                                _vm._v("未关联")
                              ])
                        ]
                      }
                    }
                  ])
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    align: "right",
                    prop: "price",
                    label: "含税价(元)",
                    width: "80"
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function(scope) {
                        return [
                          _c("span", [_vm._v(_vm._s(scope.row.price || 0.0))])
                        ]
                      }
                    }
                  ])
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    align: "right",
                    prop: "taxRate",
                    label: "税率(%)",
                    width: "80"
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function(scope) {
                        return [
                          _c("span", [_vm._v(_vm._s(scope.row.taxRate || 0))])
                        ]
                      }
                    }
                  ])
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    align: "right",
                    prop: "ntxPrice",
                    label: "未税价(元)",
                    width: "80"
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function(scope) {
                        return [
                          _c("span", [
                            _vm._v(_vm._s(scope.row.ntxPrice || 0.0))
                          ])
                        ]
                      }
                    }
                  ])
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    align: "right",
                    prop: "quantity",
                    width: "80",
                    label: "下单数量"
                  }
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    align: "center",
                    prop: "unit",
                    label: "单位",
                    width: "80"
                  }
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { align: "left", prop: "desc", label: "说明" }
                })
              ],
              1
            )
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "content-caption dashed bg-white" }, [
      _c("span", [_vm._v("基本信息")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("标题")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("要求到货日期")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("订单编号")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "content-caption dashed bg-white" }, [
      _c("span", [_vm._v("配货机构")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", { staticClass: "head" }, [
      _c("tr", { staticClass: "row" }, [
        _c("th", { staticStyle: { "text-align": "left" } }, [
          _vm._v("业务单元")
        ]),
        _vm._v(" "),
        _c("th", { staticStyle: { "text-align": "left" } }, [
          _vm._v("所属部门")
        ]),
        _vm._v(" "),
        _c("th", { staticStyle: { "text-align": "left" } }, [_vm._v("地址")]),
        _vm._v(" "),
        _c("th", { staticStyle: { "text-align": "left" } }, [_vm._v("邮箱")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "content-caption dashed bg-white" }, [
      _c("span", [_vm._v("地址信息")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", { staticClass: "head" }, [
      _c("tr", { staticClass: "row" }, [
        _c("th", { staticStyle: { "text-align": "left" } }, [
          _vm._v("地址信息")
        ]),
        _vm._v(" "),
        _c("th", { staticStyle: { "text-align": "left" } }, [
          _vm._v("详细地址")
        ]),
        _vm._v(" "),
        _c("th", { staticStyle: { "text-align": "left" } }, [_vm._v("联系人")]),
        _vm._v(" "),
        _c("th", { staticStyle: { "text-align": "left" } }, [
          _vm._v("联系电话")
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "content-caption dashed bg-white" }, [
      _c("span", [_vm._v("商品信息")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("供应商：")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4aa3f7bc", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4aa3f7bc","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/order/OrderGoodsAllocFormDetail.vue
// module id = 2669
// module chunks = 0